import _ from 'lodash';
import React, { Component } from 'react';

import {
  
} from '../../util';

import Select from 'react-select';

const ALL_TEAMS_OPTION = {
  value: 'everyone',
  label: 'Everyone',
}

const ENTIRE_TEAM_OPTION = {
  value: false,
  userData: null,
  label: 'Entire Team',
}

class UserAndTeamSelect extends Component {

  viewingTeamData(){
    return _.find(this.props.teams, { _id: this.props.viewingTeam });
  }

  userData(userId){
    return this.props.userData[userId];
  }

  viewingUserData(){
    if(!this.props.viewingTeamUser){ return null; }
    return this.props.userData[this.props.viewingTeamUser] || null;
  }

  getTeamUsersOptions(){
    if(!this.viewingTeamData()){
      return [];
    }

    const {
      leaders,
      members
    } = this.viewingTeamData();

    const memberOptions = _.map(_.union(leaders, members), userId => {

      const userData = this.userData(userId);

      return {
        value: userId,
        label: `${userData.firstName} ${userData.lastName}`
      };

    });

    return [
      ENTIRE_TEAM_OPTION,
      ...memberOptions,
    ];
  }

  getTeamOptions(){
    const { teams } = this.props;

    let teamOptions = [];

    _.each(teams || [], team => {
      teamOptions.push({
        value: team._id,
        label: team.name
      });
    });

    return [
      ALL_TEAMS_OPTION,
      ...teamOptions
    ]
  }

  getViewingTeamSelectValue(){
    const { viewingTeam } = this.props;

    const matchingTeam = _.find(this.getTeamOptions(), team => {
      return team.value === viewingTeam;
    });

    return matchingTeam;
  }

  getViewingTeamUserSelectValue(){
    const { viewingTeamUser } = this.props;

    if(!viewingTeamUser){
      return ENTIRE_TEAM_OPTION;
    }

    const matchingTeamUser = _.find(this.getTeamUsersOptions(), user => {
      return user.value === viewingTeamUser;
    });

    return matchingTeamUser || ENTIRE_TEAM_OPTION;
  }

  renderTeamUserSelect(){

    //if viewing all teams, don't render users select
    if(!this.props.viewingTeam === 'everyone'){
      return null;
    }

    const teamUsersOptions = this.getTeamUsersOptions();

    if(!teamUsersOptions || teamUsersOptions.length === 0){
      return null;
    }

    const selectedOption = this.getViewingTeamUserSelectValue();

    return (
      <Select
        classNamePrefix={'react-select'}
        className={`react-select-container member-select ${!selectedOption.value && 'none-selected'}`}
        value={selectedOption}
        options={teamUsersOptions}
        onChange={(option) => { this.props.viewUser(option.value) }}
        isSearchable={false}
      />
    )
  }

  renderTeamSelect(){

    const teamOptions = this.getTeamOptions();

    if(!teamOptions || teamOptions.length === 0){
      return null;
    }

    const selectedOption = this.getViewingTeamSelectValue();

    return (
      <Select
        classNamePrefix={'react-select'}
        className={`react-select-container team-select ${selectedOption.value === 'everyone' && 'none-selected'}`}
        value={selectedOption}
        options={teamOptions}
        onChange={(option) => { this.props.viewTeam(option.value) }}
        isSearchable={false}
      />
    );
  }

  render(){
    return (
      <React.Fragment>
        {this.renderTeamSelect()}
        {this.renderTeamUserSelect()}
      </React.Fragment>
    )
  }
}

export default UserAndTeamSelect;



// WEBPACK FOOTER //
// ./src/components/shared/userAndTeamSelect.js